import python from "../assets/img/python.png";
import java from "../assets/img/java.png";
import C from "../assets/img/C.png";
import hC from "../assets/img/h_C.png";
import js from "../assets/img/js.png";
import jq from "../assets/img/jq.gif";
import ts from "../assets/img/ts.png";
import sql from "../assets/img/mysql.png";
import firebase from "../assets/img/firebase.png";
import mongoDB from "../assets/img/mongoDB.png";
import postGreSQL from "../assets/img/postgreSql.png";
import redshift from "../assets/img/redshift.svg";
import prisma from "../assets/img/prisma.webp";
import mongoose from "../assets/img/mongoose.jpeg";
import flyway from "../assets/img/flyway.png";
import maria from "../assets/img/maria.jpeg";
import angular from "../assets/img/angular.png";
import react from "../assets/img/react.png";
import vue from "../assets/img/v.jpeg";
import remix from "../assets/img/remix.jpg";
import redux from "../assets/img/redux.png";
import vuex from "../assets/img/vuex.png";
import lambda from "../assets/img/lambda.png";
import s3 from "../assets/img/awsS3.png";
import aws from "../assets/img/aws.png";
import material from "../assets/img/materialUI.png";
import node from "../assets/img/node.png";
import express from "../assets/img/expressJS.png";
import dynamo from "../assets/img/dynamo.png";
import cognito from "../assets/img/cognito.png";
import docker from "../assets/img/docker.webp";
import cypress from "../assets/img/cypress.webp";
import jest from "../assets/img/jest.jpg";
import vitest from "../assets/img/vitest.webp";
import git from "../assets/img/git.webp";
import junit from "../assets/img/junit.webp";
import fast from "../assets/img/fast.png";
import retool from "../assets/img/retool.png";
import android from "../assets/img/android.png";
import ij from "../assets/img/ij.png";
import vs from "../assets/img/vs.svg";
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

function srcset(image, size, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${size * rows
      }&fit=crop&auto=format&dpr=2 2x`,
  };
}

export const Skills = () => {
  // const responsive = {
  //   superLargeDesktop: {
  //     // the naming can be any, depends on you.
  //     breakpoint: { max: 4000, min: 3000 },
  //     items: 5
  //   },
  //   desktop: {
  //     breakpoint: { max: 3000, min: 1024 },
  //     items: 3
  //   },
  //   tablet: {
  //     breakpoint: { max: 1024, min: 464 },
  //     items: 2
  //   },
  //   mobile: {
  //     breakpoint: { max: 464, min: 0 },
  //     items: 1
  //   }
  // };

  const itemData = [
    {
      img: python,
      title: 'Python',
      rows: 2,
      cols: 2,
      fit: 'scale-down',
    },
    {
      img: java,
      title: 'Java',
      fit: 'scale-down',
      rows: 1,
      cols: 1,
    },

    {
      img: js,
      title: 'JavaScript',
      fit: 'scale-down',
      rows: 1,
      cols: 1,
    },
    {
      img: hC,
      title: 'HTML',
      cols: 2,
      row: 1,
      fit: 'scale-down',
    },
    {
      img: C,
      title: 'C',
      cols: 1,
      row: 1,
      fit: 'scale-down',
    },

    {
      img: ts,
      title: 'Typescript',
      cols: 1,
      row: 1,
      fit: 'scale-down',
    },
    {
      img: jq,
      title: 'jQuery',
      cols: 1,
      row: 1,
      fit: 'scale-down',
    },
    {
      img: sql,
      title: 'MySQL',
      cols: 1,
      row: 1,
      fit: 'scale-down',
    },
    {
      img: firebase,
      title: 'Firebase',
      cols: 1,
      row: 1,
      fit: 'scale-down',
    },
    {
      img: mongoose,
      title: 'Mongoose',
      cols: 1,
      row: 1,
      fit: 'scale-down',
    },
    {
      img: mongoDB,
      title: 'MongoDB',
      cols: 2,
      row: 2,
      fit: 'scale-down',
    },
    {
      img: postGreSQL,
      title: 'PostgreSQL',
      cols: 2,
      row: 1,
      fit: 'scale-down',
    },
    {
      img: flyway,
      title: 'Flyway',
      cols: 1,
      row: 1,
      fit: 'scale-down',
    },
    {
      img: prisma,
      title: 'Prisma',
      cols: 1,
      rows: 1,
      fit: 'scale-down',
    },
    {
      img: redshift,
      title: 'Redshift',
      cols: 2,
      rows: 1,
      fit: 'scale-down',
    },
    {
      img: maria,
      title: 'Maria',
      cols: 1,
      rows: 1,
      fit: 'revert',
    },
    {
      img: dynamo,
      title: 'DynamoDB',
      cols: 1,
      rows: 1,
      fit: 'fill',
    },
    {
      img: react,
      title: 'React',
      cols: 2,
      rows: 2,
      fit: 'scale-down',
    }, {
      img: angular,
      title: 'Angular',
      cols: 1,
      row: 1,
      fit: 'scale-down',
    }, {
      img: vue,
      title: 'Vue',
      cols: 1,
      row: 1,
    },
    {
      img: remix,
      title: 'Remix',
      cols: 2,
      rows: 1,
    },
    {

      img: redux,
      title: 'Redux',
      cols: 1,
      rows: 1,
      fit: 'fill',
    },
    {
      img: vuex,
      title: 'Vuex',
      cols: 1,
      rows: 1,
      fit: 'fill',
    },
    {
      img: material,
      title: 'Material UI',
      cols: 2,
      rows: 1,
      fit: 'fill',
    },
    {
      img: lambda,
      title: 'Lambda',
      cols: 1,
      rows: 1,
      fit: 'fill',
    },
    {
      img: s3,
      title: 'S3',
      cols: 1,
      rows: 1,
      fit: 'fill',
    },
    {
      img: node,
      title: 'Node',
      cols: 2,
      rows: 2,
      fit: 'contain',
    },
    {
      img: express,
      title: 'Express',
      cols: 2,
      rows: 1,
      fit: 'fill',
    },
    {
      img: aws,
      title: 'AWS',
      cols: 1,
      rows: 1,
      fit: 'fill',
    },
    {
      img: cognito,
      title: 'Cognito',
      cols: 1,
      rows: 1,
      fit: 'cover',
    },
    {
      img: docker,
      title: 'Docker',
      cols: 2,
      rows: 1,
      fit: 'contain',
    },
    {
      img: cypress,
      title: 'Cypress',
      cols: 2,
      rows: 1,
      fit: 'fill',
    },
    {
      img: fast,
      title: 'FastAPI',
      cols: 2,
      rows: 1,
      fit: 'fill',
    },
    {
      img: android,
      title: 'Android',
      cols: 2,
      rows: 2,
      fit: 'scale-down',
    },

    {
      img: jest,
      title: 'Jest',
      cols: 1,
      rows: 1,
      fit: 'fill',

    },
    {
      img: vitest,
      title: 'Vitest',
      cols: 1,
      rows: 1,
      fit: 'fill',
    },
    {
      img: retool,
      title: 'Retool',
      cols: 2,
      rows: 1,
      fit: 'cover',
    },
    {
      img: git,
      title: 'Git',
      cols: 2,
      rows: 1,
    },
    {
      img: junit,
      title: 'Junit',
      cols: 2,
      rows: 1,
      fit: 'fill',
    },
    {
      img: ij,
      title: 'IntelliJ',
      cols: 1,
      rows: 1,
      fit: 'contain',
    },
    {
      img: vs,
      title: 'VS Code',
      cols: 1,
      rows: 1,
      fit: 'fill',
    }
  ];


  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p>These are few tools and technologies I have worked with
              </p>
              <ImageList className="skill-bx wow zoomIn"
                sx={{ maxWidth: 1200, height: 700, minHeight: 450 }}
                variant="quilted"
                cols={6}
                rowHeight={120}
              >
                {itemData.map((item) => (
                  <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>
                    <img
                      {...srcset(item.img, 300, item.rows, item.cols)}
                      alt={item.title}
                      loading="lazy"
                      style={{ objectFit: item.fit || 'cover' }}
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="background" />
    </section>
  )
}
